export default __webpack_public_path__ + "static/media/suite-montanha1-4.296b9df0.webp";